import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { ColorModeProvider, useColorMode } from '@/context/ColorModeContext';
import { getCustomTheme } from '@/styles/theme';
import '@/styles/globals.css';
import AppRouter from '@/router/AppRouter';

const ThemedApp: React.FC = () => {
  const { mode } = useColorMode();
  const theme = React.useMemo(() => getCustomTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRouter />
    </ThemeProvider>
  );
};

export const App: React.FC = () => {
  return (
    <ColorModeProvider>
      <ThemedApp />
    </ColorModeProvider>
  );
};

export default App;
